export default class Queue {
  constructor(onConsume) {
    this.items = []
    this.printingInterval = null
    this.onConsume = onConsume
  }

  // 入队操作
  enqueue(element) {
    this.items.push(element)
  }

  // 出队操作并返回元素
  dequeue() {
    if (this.isEmpty()) {
      return ''
    }
    return this.items.shift()
  }

  // 检查队列是否为空
  isEmpty() {
    return this.items.length === 0
  }
  printing() {
    this.printingInterval = setInterval(() => {
      const char = this.dequeue()
      this.onConsume(char)
    }, 50) //每100毫秒打印一个字符
  }
  // 渲染完之后需要回收定时器
  done() {
    this.clear()
    // 把queue中剩下的字符一次性消费
    this.onConsume(this.items.join(''))
    this.items = []
  }
  clear() {
    clearInterval(this.printingInterval)
  }
}
